<tmx-nav-dropdown
  [disabled]="(disabled$ | async) === true"
  (opened)="openMenu()"
  ariaLabel="{{ t('orderTracking.orderTracking.notifications') }}"
  (closed)="closeMenu()"
  dropdownTooltip="{{ t('orderTracking.orderTracking.notifications') }}"
  *transloco="let t"
>
  <div class="shadow dropdown-body pe-3" role="menu" container="body">
    <div class="title">
      <h5 class="m-0">
        {{ t('orderTracking.orderTracking.pendingRequests') }}
      </h5>
    </div>

    <div class="header shadow">
      <table class="table">
        <thead>
          <tr>
            <th>
              {{
                displayTimeZone(t('orderTracking.orderTracking.requestedDate'))
              }}
            </th>
            <th>{{ t('orderTracking.orderTracking.accountName') }}</th>
            <th>{{ t('orderTracking.orderTracking.status') }}</th>
          </tr>
        </thead>
      </table>
    </div>

    <div class="scroll-container overflow-y-auto">
      <table class="table table-sm m-0">
        <tbody>
          <tr *ngFor="let notification of notifications$ | async">
            <td class="border-bottom">
              {{ formatDate(notification.createdOn) }}
            </td>
            <td class="border-bottom">{{ notification.targetAccountName }}</td>
            <td class="border-bottom">
              {{ notification.orderStatus | status }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div icon>
    <span *ngIf="showUnread$ | async" class="badge rounded-pill bg-danger">{{
      unread$ | async | unread
    }}</span>
    <i
      class="modus-icons text-white notranslate"
      aria-hidden="true"
      [attr.aria-label]="t('orderTracking.orderTracking.notifications')"
      >notifications</i
    >
  </div>
</tmx-nav-dropdown>
